/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response status from a participant for a meeting invite.
 */
export type InviteResponseStatus = (typeof InviteResponseStatus)[keyof typeof InviteResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InviteResponseStatus = {
  none: 'none',
  accepted: 'accepted',
  declined: 'declined',
  tentativelyAccepted: 'tentativelyAccepted',
  notResponded: 'notResponded',
} as const;
